import React from "react";
import { View, StyleSheet } from "react-native";
import { Option, Title, InputBox } from "../../accessories/accessories";
import { web } from "../../accessories/Platform";
import Dropdown from "../../accessories/DropDown";
import { value } from "deprecated-react-native-prop-types/DeprecatedTextInputPropTypes";
import { cleanValue, log } from "../../accessories/CommonFunctions";

const Government = ({ detailsArr, handleOptionPress }) => {
  detailsArr["subFields"] = detailsArr["subFields"]?.filter((e) => e !== null);

  const typeTwoFields =
    detailsArr["subFields"]?.length > 0 ? detailsArr["subFields"] : [];
  const getOptionValue = (item, item_) => {
    if (item["isBitWise"]) {
      return (
        (Number(item_["value"]) & Number(item["ColumnValue"])) ==
        Number(item_["value"])
      );
    } else return item_["value"] === item["ColumnValue"];
  };
  const getTextAreaProps = (type) => {
    return type === 5 ? { textAlignVertical: "top", multiline: true } : {};
  };
  return (
    <View>
      <Title text={detailsArr["Title"]} />
      <View>
        <View
          style={
            detailsArr["widthOption"] !== undefined
              ? { flexDirection: "row", justifyContent: "space-around" }
              : { flex: 1 }
          }
        >
          {detailsArr["Options"]?.map((item, index) => (
            <Option
              key={index}
              style={
                detailsArr["widthOption"] !== undefined
                  ? { width: detailsArr["widthOption"] }
                  : {}
              }
              text={item["text"]}
              value={item["value"] === detailsArr["ColumnValue"]}
              onPress={() =>
                handleOptionPress(item["value"], null, null, null, null)
              }
            />
          ))}
        </View>
      </View>
      {typeTwoFields?.length > 0 && (
        <>
          <View>
            {typeTwoFields?.map((item, index) => (
              <View key={index}>
                <Title
                  text={item["Title"]}
                  style={[
                    {
                      marginBottom: item["type"] === 1 ? 10 : 15,
                    },
                    item["isYellow"] && {
                      backgroundColor: "yellow",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      alignSelf: "flex-start",
                    },
                  ]}
                />
                {[2, 5].indexOf(item["type"]) > -1 ? (
                  <InputBox
                    {...getTextAreaProps(item["type"])}
                    label={item["label"]}
                    charLength={item["charLength"]}
                    keyboardType={item["keyboardType"]}
                    maxLength={item["maxLength"]}
                    forceValidation={item["forceValidation"]}
                    isCurrency={item["isCurrency"]}
                    disabled={item["disabled"] || false}
                    validate={item["isValid"] || false}
                    placeholder={item["placeholder"] || item["label"]}
                    onBlur={() =>
                      item["onBlur"] !== undefined
                        ? item["onBlur"](item["ColumnValue"]?.toString())
                        : () => {}
                    }
                    onChangeText={(text) => {
                      try {
                        if (detailsArr["onChangeText"])
                          detailsArr["onChangeText"](item["ColumnName"], text);
                        else handleOptionPress(text, true, index);
                      } catch (e) {
                        log("Error from  ====> ", e);
                      }
                    }}
                    value={item["ColumnValue"]?.toString()}
                    onFocus={() => {
                      let val = item["ColumnValue"]?.toString();
                      if (val?.includes("$")) {
                        let text =
                          cleanValue(val) == 0 ? "" : val?.replaceAll("$", "");
                        try {
                          if (detailsArr["onChangeText"])
                            detailsArr["onChangeText"](
                              item["ColumnName"],
                              text
                            );
                          else handleOptionPress(text, true, index);
                        } catch (e) {
                          log("Error from  ====> ", e);
                        }
                      }
                    }}
                  />
                ) : item["type"] === 3 ? (
                  <>
                    <Dropdown
                      isValid={item["isValid"]}
                      label={item["label"]}
                      options={item["Option"]}
                      value={
                        item["isMap"]
                          ? item["Option"].filter(
                              (e) => e["value"] == item["ColumnValue"]
                            )[0]?.label
                          : item["ColumnValue"]
                      }
                      onSelect={(item_) => {
                        if (detailsArr["onChangeText"])
                          detailsArr["onChangeText"](
                            item["ColumnName"],
                            item_["value"]
                          );
                        else
                          handleOptionPress(
                            item_["value"],
                            null,
                            null,
                            item["ColumnName"]
                          );
                      }}
                      placeholder={item["placeholder"] || ""}
                      isMap={item["isMap"]}
                    />
                  </>
                ) : item["type"] === 1 ? (
                  <>
                    <View>
                      <View
                        style={
                          item["widthOption"] !== undefined
                            ? {
                                flexDirection: "row",
                                justifyContent: "space-around",
                              }
                            : { flex: 1 }
                        }
                      >
                        {item["Options"]?.map((item_, index) => (
                          <Option
                            key={index}
                            style={
                              item["widthOption"] !== undefined
                                ? { width: item["widthOption"] }
                                : {}
                            }
                            text={item_["text"]}
                            value={getOptionValue(item, item_)}
                            onPress={() => {
                              if (item["onPress"] !== undefined) {
                                item["onPress"]();
                              } else if (detailsArr["onChangeText"])
                                detailsArr["onChangeText"](
                                  item["ColumnName"],
                                  item_["value"]
                                );
                              else
                                handleOptionPress(
                                  item_["value"],
                                  null,
                                  null,
                                  item["ColumnName"],
                                  null
                                );
                            }}
                          />
                        ))}
                      </View>
                    </View>
                  </>
                ) : (
                  <></>
                )}
              </View>
            ))}
          </View>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  inputBoxContainer: {
    flexDirection: "row",
    borderColor: "gray",
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    marginBottom: 20,
  },
  iconButtonContainer: {
    backgroundColor: "#1a63ad",
    borderRadius: 25,
    height: 45,
    paddingVertical: 10,
    paddingHorizontal: 10,
    marginTop: 8,
    paddingTop: web ? "5px" : null,
    alignSelf: "flex-start",
    padding: 30,
  },
  iconButtonText: {
    fontSize: 18,
    color: "#fff",
  },
  inputBoxLabel: {
    position: "absolute",
    backgroundColor: "#fff",
    top: -12,
    left: 3,
    fontSize: 14,
    color: "gray",
    paddingHorizontal: 3,
  },
  inputBox: {
    ...{
      borderWidth: 0,
      borderRadius: 5,
      fontSize: web ? 15 : 16,
      backgroundColor: "rgba(0,0,0,.04)",
      color: "#51575d",
      width: "100%",
      padding: 5,
    },
  },
});

export default Government;
